import { useQuery } from "@tanstack/react-query";
import type { MerchantDraftShareSummary } from "@unbox/api";
import { handleError } from "@/api/error";
import { client } from "./client";

export type { MerchantDraftShareSummary };

export const useMerchantDraftShare = (shareToken: string) =>
  useQuery<MerchantDraftShareSummary>({
    queryKey: ["merchant-draft-share", shareToken],
    queryFn: async () => {
      const res = await client.tiktok.connect.draft[":shareToken"].$get({ param: { shareToken } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    refetchInterval: 5000,
  });

export const draftShareUrl = (shareToken: string) => `${window.location.origin}/connect/merchant/${shareToken}`;

export const draftAuthoriseUrl = (shareToken: string) =>
  `${import.meta.env.VITE_API_URL}/tiktok/connect/draft/${shareToken}/shop`;
